export const GET_PESERTA='GET_PESERTA'

export const GET_RIWAYAT='GET_RIWAYAT'

export const GET_LOG='GET_LOG'

export const GET_DETAIL_LOG='GET_DETAIL_LOG'

export const SET_PESERTA='SET_PESERTA'